import React, { useRef, useEffect, useState } from "react";
import Hls from "hls.js";

export default function HlsPlayer({ url, fallbackImage }) {
  const videoRef = useRef(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !url) return;

    setHasError(false); // reset error when URL changes

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(video);

      // Handle HLS load errors (e.g. 404)
      hls.on(Hls.Events.ERROR, (event, data) => {
        if (data.fatal || data.response?.code === 404) {
          console.error("HLS stream error:", data);
          setHasError(true);
          hls.destroy();
        }
      });

      return () => hls.destroy();
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      // Safari native HLS
      video.src = url;
      video.onerror = () => setHasError(true);
    }
  }, [url]);

  if (hasError) {
    return (
      <div
        className="video-container"
        style={{
          width: "100%",
          maxWidth: "640px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <img
          src={fallbackImage || "/images/stream-offline.jpg"}
          alt="Stream unavailable"
          style={{
            width: "100%",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          }}
        />
        <p style={{ marginTop: "10px", color: "#555", fontWeight: "600" }}>
          Live stream is currently unavailable
        </p>
      </div>
    );
  }

  return (
    <div
      className="video-container"
      style={{
        width: "100%",
        maxWidth: "640px",
        margin: "0 auto",
      }}
    >
      <video
        ref={videoRef}
        controls
        muted
        style={{
          width: "100%",
          borderRadius: "12px",
        }}
      />
    </div>
  );
}
